import { omit } from 'lodash';
import mergeStyleToAttributes from '../mergeStyleToAttributes';
import { BLACKLISTED_PROPS } from './constants';

/**
 * Return Layer's "cleaned" props by omitting blacklisted.
 * @param props - Props to clean
 * @returns {Object}
 */
const getLayerProps = (props) =>
    omit(
        {
            ...props,
            ...mergeStyleToAttributes(props),
        },
        BLACKLISTED_PROPS
    );

export default getLayerProps;
